const apps = {
  state: {
    username: '',
    password: '',
    login_status: false
  },
  mutations: {
    setLoginStatus (state: any, payload: any) {
      state.login_status = payload
    }
  }
}

export default apps
